/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AdditionalEquipmentFromJSON, AdditionalEquipmentToJSON, ApplicationUserFromJSON, ApplicationUserToJSON, BodyProtocolStateFromJSON, BodyProtocolStateToJSON, CarFromJSON, CarToJSON, CarCollectionFromJSON, CarCollectionToJSON, EmployeeFromJSON, EmployeeToJSON, FuelLevelFromJSON, FuelLevelToJSON, InteriorProtocolStateFromJSON, InteriorProtocolStateToJSON, ProtocolDamageDetailFromJSON, ProtocolDamageDetailToJSON, ProtocolDamageModelFromJSON, ProtocolDamageModelToJSON, ProtocolHtmlFromJSON, ProtocolHtmlToJSON, ProtocolTypeFromJSON, ProtocolTypeToJSON, } from './';
export function ProtocolFromJSON(json) {
    return ProtocolFromJSONTyped(json, false);
}
export function ProtocolFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'carCollectionId': !exists(json, 'carCollectionId') ? undefined : json['carCollectionId'],
        'carCollection': !exists(json, 'carCollection') ? undefined : CarCollectionFromJSON(json['carCollection']),
        'car': !exists(json, 'car') ? undefined : CarFromJSON(json['car']),
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'signedByCustomer': !exists(json, 'signedByCustomer') ? undefined : json['signedByCustomer'],
        'protocolNumber': json['protocolNumber'],
        'accepted': !exists(json, 'accepted') ? undefined : (new Date(json['accepted'])),
        'acceptedByEmployee': !exists(json, 'acceptedByEmployee') ? undefined : EmployeeFromJSON(json['acceptedByEmployee']),
        'acceptedByEmployeeId': !exists(json, 'acceptedByEmployeeId') ? undefined : json['acceptedByEmployeeId'],
        'mileage': !exists(json, 'mileage') ? undefined : json['mileage'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'type': !exists(json, 'type') ? undefined : ProtocolTypeFromJSON(json['type']),
        'hasDamage': !exists(json, 'hasDamage') ? undefined : json['hasDamage'],
        'bodyState': !exists(json, 'bodyState') ? undefined : BodyProtocolStateFromJSON(json['bodyState']),
        'interiorState': !exists(json, 'interiorState') ? undefined : InteriorProtocolStateFromJSON(json['interiorState']),
        'fuelLevel': !exists(json, 'fuelLevel') ? undefined : FuelLevelFromJSON(json['fuelLevel']),
        'additionalCostFuel': !exists(json, 'additionalCostFuel') ? undefined : json['additionalCostFuel'],
        'additionalCostClean': !exists(json, 'additionalCostClean') ? undefined : json['additionalCostClean'],
        'additionalCostOther': !exists(json, 'additionalCostOther') ? undefined : json['additionalCostOther'],
        'additionalEquipment': !exists(json, 'additionalEquipment') ? undefined : (json['additionalEquipment'] === null ? null : json['additionalEquipment'].map(AdditionalEquipmentFromJSON)),
        'damageModels': !exists(json, 'damageModels') ? undefined : (json['damageModels'] === null ? null : json['damageModels'].map(ProtocolDamageModelFromJSON)),
        'damageDetails': !exists(json, 'damageDetails') ? undefined : (json['damageDetails'] === null ? null : json['damageDetails'].map(ProtocolDamageDetailFromJSON)),
        'documentFileId': !exists(json, 'documentFileId') ? undefined : json['documentFileId'],
        'documentFile': !exists(json, 'documentFile') ? undefined : json['documentFile'],
        'signatureCustomerFile': !exists(json, 'signatureCustomerFile') ? undefined : json['signatureCustomerFile'],
        'signatureCustomerFileId': !exists(json, 'signatureCustomerFileId') ? undefined : json['signatureCustomerFileId'],
        'signatureEmployeeFile': !exists(json, 'signatureEmployeeFile') ? undefined : json['signatureEmployeeFile'],
        'signatureEmployeeFileId': !exists(json, 'signatureEmployeeFileId') ? undefined : json['signatureEmployeeFileId'],
        'protocolHtmlId': !exists(json, 'protocolHtmlId') ? undefined : json['protocolHtmlId'],
        'protocolHtml': !exists(json, 'protocolHtml') ? undefined : ProtocolHtmlFromJSON(json['protocolHtml']),
    };
}
export function ProtocolToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'carCollectionId': value.carCollectionId,
        'carCollection': CarCollectionToJSON(value.carCollection),
        'car': CarToJSON(value.car),
        'carId': value.carId,
        'signedByCustomer': value.signedByCustomer,
        'protocolNumber': value.protocolNumber,
        'accepted': value.accepted === undefined ? undefined : (value.accepted.toISOString()),
        'acceptedByEmployee': EmployeeToJSON(value.acceptedByEmployee),
        'acceptedByEmployeeId': value.acceptedByEmployeeId,
        'mileage': value.mileage,
        'notes': value.notes,
        'type': ProtocolTypeToJSON(value.type),
        'hasDamage': value.hasDamage,
        'bodyState': BodyProtocolStateToJSON(value.bodyState),
        'interiorState': InteriorProtocolStateToJSON(value.interiorState),
        'fuelLevel': FuelLevelToJSON(value.fuelLevel),
        'additionalCostFuel': value.additionalCostFuel,
        'additionalCostClean': value.additionalCostClean,
        'additionalCostOther': value.additionalCostOther,
        'additionalEquipment': value.additionalEquipment === undefined ? undefined : (value.additionalEquipment === null ? null : value.additionalEquipment.map(AdditionalEquipmentToJSON)),
        'damageModels': value.damageModels === undefined ? undefined : (value.damageModels === null ? null : value.damageModels.map(ProtocolDamageModelToJSON)),
        'damageDetails': value.damageDetails === undefined ? undefined : (value.damageDetails === null ? null : value.damageDetails.map(ProtocolDamageDetailToJSON)),
        'documentFileId': value.documentFileId,
        'documentFile': value.documentFile,
        'signatureCustomerFile': value.signatureCustomerFile,
        'signatureCustomerFileId': value.signatureCustomerFileId,
        'signatureEmployeeFile': value.signatureEmployeeFile,
        'signatureEmployeeFileId': value.signatureEmployeeFileId,
        'protocolHtmlId': value.protocolHtmlId,
        'protocolHtml': ProtocolHtmlToJSON(value.protocolHtml),
    };
}
